import { baseURL } from "server-api";

export default function ListItem({thumbnail, title, createdAt}){
  const time = createdAt.split('T')[0];
  const url = `${baseURL}${thumbnail}`
  return (
    <div>
      <div className="w-[160px] lg:w-[380px] flex flex-col drop-shadow-lg m-2 hover:border-sky-400 border border-gray-200">
        <div className={`flex justify-center h-[120px] lg:h-[250px] bg-gray-50`}>
          {thumbnail!==undefined ? 
            <img src={`${url}`} className="object-scale-down"
              alt={`${title}'s thumbnail`}/>
          : 
            null
          }
        </div>
        <div className="w-full p-4 bg-white lg:p-10">
          <p className="truncate">{title}</p>
          <p className="text-sm text-gray-500">{time}</p>
        </div>
      </div>
    </div>
  );
}